module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Compiling-2b249961a76a0049e0e92f7b470514ee.svg";